import React, { useState } from 'react';
import styled from 'styled-components';
import { FormikTextinput } from '@zimpel/common/components/formikAdapters';
import type { FormikTextinputProps } from '@zimpel/common/components/formikAdapters';
import { EyeIcon, EyeSlashIcon } from '@zimpel/common/components/Icon';
import { SwitchButton } from '../Buttons';

const Wrapper = styled.div`
  position: relative;
`;

const Eye = styled.div`
  position: absolute;
  top: 2px;
  right: 2px;
`;

const StyledInput = styled(FormikTextinput)`
  padding-right: 2rem;
`;

const PasswordField: React.FC<FormikTextinputProps> = (props) => {
  const [isHidden, setIsHidden] = useState(true);

  return (
    <Wrapper>
      <StyledInput
        {...props}
        type={isHidden ? 'password' : 'text'}
      />
      <Eye>
        <SwitchButton
          type="button"
          active
          icon={isHidden ? EyeSlashIcon : EyeIcon}
          onClick={() => setIsHidden(!isHidden)}
        />
      </Eye>
    </Wrapper>
  );
};
export default PasswordField;
